import React from "react";

type TableHeaderMethodologiesProps = {
  headers: string[];
};

const TableHeaderMethodologies: React.FC<TableHeaderMethodologiesProps> = ({
  headers,
}) => {
  return (
    <thead>
      <tr
        style={{
          backgroundColor: "#428bca",
          color: "#fff",
          borderTop: "none",
        }}
      >
        {headers.map((header) => (
          <th>{header}</th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeaderMethodologies;
